module.exports = __webpack_public_path__ + "static/media/b2c-image-pandahao.9fe840ad.png";